/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExportedCredentialBase
 */
export interface ExportedCredentialBase {
    /**
     * The ID of the credential
     * @type {string}
     * @memberof ExportedCredentialBase
     */
    id: string;
    /**
     * The time when the credential was last used to authenticate successfully
     * @type {Date}
     * @memberof ExportedCredentialBase
     */
    last_used?: Date;
}

/**
 * Check if a given object implements the ExportedCredentialBase interface.
 */
export function instanceOfExportedCredentialBase(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function ExportedCredentialBaseFromJSON(json: any): ExportedCredentialBase {
    return ExportedCredentialBaseFromJSONTyped(json, false);
}

export function ExportedCredentialBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExportedCredentialBase {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'last_used': !exists(json, 'last_used') ? undefined : (new Date(json['last_used'])),
    };
}

export function ExportedCredentialBaseToJSON(value?: ExportedCredentialBase | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'last_used': value.last_used === undefined ? undefined : (value.last_used.toISOString()),
    };
}

